import api from './cms-api';

async function getOperationsPageAPI() {
  const response = await api.get(
    'get_operations_page/',
  );
  return response?.data;
}

export default getOperationsPageAPI;
